import React, { Component } from 'react';
import { withRouter } from 'react-router'
import { LinkContainer } from 'react-router-bootstrap'
import { Map, Marker, TileLayer, Popup } from 'react-leaflet';
import { Button } from 'react-bootstrap';
import { observer } from 'mobx-react'
import sensors from '../../stores/sensors'
import Loading from '../../Loading'
import Spiderfy from "../Spiderfy";
import './SensorMap.css';



export default withRouter(observer(class SensorMap extends Component {

  mapCentre = [56.3887691,-4.2948678]
  zoom = 7

  constructor(props) {
    super(props)

    if(this.props.zoom) {
      this.mapCentre = this.props.zoom
    }

    if(sensors.length === 0 && !sensors.isRequest('fetching')) {
      sensors.fetch()
    }
  }

  componentDidMount () {
    if(sensors.length === 0 && !sensors.isRequest('fetching')) {
      sensors.fetch()
    }
  }

  render() {

    if (sensors.isRequest('fetching')) {
      return <Loading label='map' />
    }

    var mappableSensors = []
    sensors.models.forEach(function(sensor)
      {
        if (sensor.latlong[0] !== 0 || sensor.latlong[1] !== 0) {
          mappableSensors.push(sensor)
        }
      }
    )

    return (
    <Map
      center={this.mapCentre}
      zoom={this.zoom}
      maxZoom={12}
      maxNativeZoom={12} >
        <TileLayer
          url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        />
        <Spiderfy>
          {
            mappableSensors.map(sensor => (
              <Marker key={sensor.get('slug')} position={sensor.latlong}>
              <Popup className="rt-popup" closeButton="true">
                <span>
                  <h4>{sensor.get('name')}</h4>
                  <LinkContainer to={`/location/${sensor.get('slug')}`}>
                    <Button>Show...</Button>
                  </LinkContainer>
                </span>
              </Popup>
              </Marker>
            ))
          }
        </Spiderfy>
      </Map>
    );
  }

}))



// WEBPACK FOOTER //
// ./src/components/sensormap/SensorMap.js